import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Citation {
  file_name: string;
  updated_at: string;
}

@Component({
  selector: 'rn-citation-collapsoid',
    standalone: true,
  imports: [CommonModule],
  templateUrl: './citation-collapsoid.component.html',
  styleUrl: './citation-collapsoid.component.scss',
})
export class CitationCollapsoidComponent {
  @Input({ required: true }) citations: Citation[] = [];

  isExpanded = false;

  toggleCitations(): void {
    this.isExpanded = !this.isExpanded;
  }

  getRelativeTime(dateString: string): string {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);

    if (diffHours < 1) {
      return 'Modified just now';
    } else if (diffHours < 24) {
      return `Modified ${diffHours} hour${diffHours === 1 ? '' : 's'} ago`;
    } else if (diffDays < 30) {
      return `Modified ${diffDays} day${diffDays === 1 ? '' : 's'} ago`;
    } else {
      const diffMonths = Math.floor(diffDays / 30);
      return `Modified ${diffMonths} month${diffMonths === 1 ? '' : 's'} ago`;
    }
  }
}
